import React from 'react';
import debounce from 'lodash/debounce';
import axios from 'axios';
import Search from '@material-ui/icons/Search';
import { RadioGroup, Radio, ThemeProvider, Button } from '@workboard/wobo-ui';
import SearchServices from '../../services/search.services';
import SearchUtils from './search-util';
import { withTranslation } from 'react-i18next';
import { getAiTypeActionLabelPlural } from '../../board/utils';

let CancelToken = axios.CancelToken;

class SearchTagComp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            tags: this.props.tags || [],
            suggestions: [],
            operator: location.search.includes('operator=or') ? 'or' : 'and',
        };

        this.inputKeyPress = this.inputKeyPress.bind(this);
        this.onChangeSearchTag = this.onChangeSearchTag.bind(this);
        this.removeSelectedItem = this.removeSelectedItem.bind(this);
        this.clickSuggestion = this.clickSuggestion.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.resizeInput = this.resizeInput.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.generateSearchEvent = this.generateSearchEvent.bind(this);

        this.searchServices = new SearchServices();
        this.searchTag = React.createRef();
        this.cancelRequest = null;

        this.delayedCalleback = debounce(this.apiCall, 300);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        if (this.searchTag.current && !this.props.viewMode) {
            this.searchTag.current.focus();
        }
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                suggestions: [],
                searchText: ''
            }, () => {
                this.clearInput();
            });
        }
    }

    apiCall() {
        let params = {};
        params.i = this.props.currentUserId;
        params.term = this.state.searchText;
        let _this = this;
        if (_this.cancelRequest != null) {
            _this.cancelRequest();
        }
        axios({
            method: 'get',
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            url: wbConfig.baseUrl + '/search/searchTag',
            cancelToken: new CancelToken(function executor(c) {
                _this.cancelRequest = c;
            }),
            params
        })
        .then(response => {
            if (response.data) {
                let data = Array.isArray(response.data) ? response.data : [];
                if (data.length == 1 && data[0]['id'] == '0') {
                    // no results found.
                    data = [];
                }
               _this.setState({
                    suggestions: data
               });
            }
        });

        const searchCount = this.state.searchCount ? (this.state.searchCount + 1) : 1;
        this.setState({ searchCount });
        this.generateSearchEvent();
    }

    onChangeSearchTag(e) {
        e.persist();
        let val = e.target.value.trim();
        let tags = this.state.tags;
        if (tags.length) {
            e.target.style.width = (val.length + 2) + "ch";
        }
        this.setState({
            searchText: val
        },
        () => {
            this.delayedCalleback();
        });
    }

    handleSubmit = () => {
        const { operator, tags } = this.state;
        if (tags.length) {
            let ids = tags.filter(tag => tag.type != 3).map(tag => tag.id);
            let tagIds = ids.join(',');
            let krIdArr = tags.filter(tag => tag.type == 3);
            let krId= '';
            if(krIdArr.length > 0) {
                let tagKrIds = krIdArr.map(tag => tag.id);
                let krIds = tagKrIds.join(',');
                krId = '&kr_tag_id='+krIds;
            }
            window.location = `
                ${wbConfig.baseUrl}/activity/searchlist?id=${tagIds}&t=tag&type=tag${krId}&operator=${operator}
            `;
        }
    }

    inputKeyPress(e) {
        if (e.key !== 'Enter') return;
        this.handleSubmit();
    }

    resizeInput(focus = false) {
        let value = this.state.searchText;
        if (this.searchTag.current) {
            if (value.length) {
                this.searchTag.current.style.width = (value.length + 2) + "ch";
            }
            else {
                this.searchTag.current.style.width = "36ch";
            }
            if (focus && !this.props.viewMode) {
                this.searchTag.current.focus();
            }
        }
    }

    renderSelectedTags() {
        const { t } = this.props;
        const tags = this.state.tags;
        const inputProps = {};
        if (this.props.viewMode) {
            inputProps.readOnly = true;
        }
        if (!tags.length) {
            return (
                <div className='searchtag-input-box'>
                    {
                        (!this.props.viewMode) ?
                            <input
                                className={'searchtag-input ' + (!tags.length ? ' searchtag-input-placetext ' : '')}
                                ref={this.searchTag}
                                defaultValue={this.state.searchText}
                                placeholder={ !tags.length ? t('Search for tag(s) and press enter') : '' }
                                onChange={(e) => this.onChangeSearchTag(e)}
                                onKeyDown={(e) => this.inputKeyPress(e)}
                                {...inputProps}
                                data-testid="search-tag-input"
                            />
                        : ''
                    }
                </div>
            );
        }
        return (
            <div className='searchtag-selected'>
                {
                    this.state.tags.map((tag, index) => (
                        <div key={'searchtag-' + index} className={"searchtag-token searchtag-token-type-" + tag.type}>
                            <span className={'icon ' + this.getIconClass(tag.type)}></span>
                            <span className="searchtag-token-label truncate">{tag.value}</span>
                            {
                                !this.props.viewMode ? 
                                <span className="searchtag-close" onClick={() => this.removeSelectedItem(tag)}>×</span>
                                : ''
                            }
                        </div>
                    ))
                }
                <div className='searchtag-input-box'>
                    {
                        (!this.props.viewMode) ?
                            <input className={'searchtag-input ' + (!tags.length ? ' searchtag-input-placetext ' : '')}
                            ref={this.searchTag}
                            defaultValue={this.state.searchText}
                            placeholder={ !tags.length ? t('Search for tag(s) and press enter') : '' }
                            onChange={(e) => this.onChangeSearchTag(e)}
                            onKeyDown={(e) => this.inputKeyPress(e)}
                            {...inputProps}
                            data-testid="search-tag-input"
                        />
                        : ''
                    }
                </div>
            </div>
        );
    }

    removeSelectedItem(item) {
        let tags = this.state.tags.filter(tag => tag.id != item.id);
        this.setState({
            tags
        }, () => {
            this.resizeInput(true);
        });
    }

    clearInput() {
        if (this.searchTag.current && !this.props.viewMode) {
            this.searchTag.current.value = '';
            this.searchTag.current.focus();
        }
    }

    clickSuggestion(suggestion) {
        let tags = this.state.tags;
        let findItem = tags.find(tag => tag.id == suggestion.id);
        if (!findItem) {
            tags = tags.concat(suggestion);
        }
        this.setState({
            tags,
            suggestions: [],
            searchText: ''
        }, () => {
            this.clearInput();
        });
    }

    handleCheckboxChange = (e) => {
        this.setState({
            operator: e.target.value
        });
    }

    getIconClass(type = 1) {
        let icon = 'icon-outline-person_outline-24px-limegreen';
        if(type == 2) {
            icon = ' icon-outline-people-24px-aquablue';
        } else if(type == 3) {
            icon = 'icon-KR-24px';
        }
        return icon;
    }

    generateSearchEvent() {
        const eventType = (this.state.searchCount > 1)
            ? 'GLOBAL_SEARCH_POP_UP'
            : 'GLOBAL_SEARCH_USED';
        const properties = { tag: 'YES' };

        SearchUtils.pushGlobalSearchEvent(eventType, properties);
    }

    renderSuggestionList(suggestion, index = 0) {
        const iconClass = this.getIconClass(suggestion.type);
        return (
            <div key={'suggestion-' + index} className="searchtag-suggestion-item" onClick={() => this.clickSuggestion(suggestion)}>
                <i className={'left icon ' + iconClass}></i>
                <div className="left truncate">{suggestion.value}</div>
                <div className='clear'></div>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const { tags, suggestions, operator } = this.state;
        const tagsLength = tags.length;
        const suggestionsLength = suggestions.length;
        const borderClass = suggestionsLength ? ' borderbox ' : '';
        let wrapperProps = {};
        const { viewMode } = this.props;
        if (this.props.viewMode) {
            wrapperProps.onClick = this.props.openGlobalSearchList;
            wrapperProps.style = {cursor: 'pointer'};
        }

        const radioGroupId = `search-tag-operator-radio${viewMode ? '-viewMode' : ''}`;

        return (
            <div className='searchtag-comp-wrapper' ref={node => (this.wrapperRef = node)}>
                <div className={'searchtag-box-wrapper ' + borderClass} data-testid="searchtag-box-wrapper" >
                    <div className='searchtag-box' {...wrapperProps} data-testid="searchtag-box">
                        {
                            <div style={{ flexShrink: 0 }}>
                                <Search color="#8490A3" size="small" />
                            </div>
                        }
                        {
                            this.renderSelectedTags()
                        }
                    </div>
                    {
                        (!suggestionsLength && tagsLength && !viewMode) ? 
                            <div className='searchtag-placeholder-text'>
                              
                                <div className='searchtag-placeholder'>
                                    {t('Search for tag(s) and press enter')}
                                </div>
                                
                            </div>
                        : ''
                    }
                    <ThemeProvider>
                        <p style={{ margin: '10px 0 0 0' }}>{t('Show me {{actionLabelPlural}} that have:', { nsSeparator: false, actionLabelPlural: getAiTypeActionLabelPlural().toLowerCase() })}</p>
                        <RadioGroup
                            name="operator"
                            value={operator}
                            id={radioGroupId}
                            onChange={this.handleCheckboxChange}
                        >
                            <div style={{ display: 'flex', gap: '30px' }}>
                                <Radio
                                    value="and"
                                    isDisabled={viewMode}
                                    label={t("All of these tags")}
                                />
                                <Radio
                                    value="or"
                                    isDisabled={viewMode}
                                    label={t("Any of these tags")}
                                />
                            </div>
                        </RadioGroup>
                        {!viewMode && (
                            <Button
                                variant="primary"
                                onClick={this.handleSubmit}
                                isDisabled={!tags.length}
                                style={{ display: 'block', marginTop: '10px' }}
                            >
                                {t('Search')}
                            </Button>
                        )}
                    </ThemeProvider>
                    {
                        !this.props.viewMode && suggestionsLength ?
                        <div className={'searchtag-suggestions-wrapper ' + borderClass } data-testid="search-tag-suggestions">
                            {
                                suggestions.map((suggestion, index) => this.renderSuggestionList(suggestion, index))
                            }
                        </div>
                        : null
                    }
                </div>
            </div>
       );
    }
}

SearchTagComp.defaultProps = {
    tags: [],
    currentUserId: null,
    viewMode: false,
    openGlobalSearchList: null
};

export default withTranslation()(SearchTagComp);